import { render, staticRenderFns } from "./SpendCell.vue?vue&type=template&id=10c7d2c7"
import script from "./SpendCell.vue?vue&type=script&lang=js"
export * from "./SpendCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports